import React, { createContext, useContext, useState, useMemo } from 'react';

export type LanguageMode = 'de' | 'en' | 'dual';

interface LanguageContextValue {
  mode: LanguageMode;
  setMode: (mode: LanguageMode) => void;
}

const LanguageModeContext = createContext<LanguageContextValue | undefined>(undefined);

export const LanguageModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mode, setMode] = useState<LanguageMode>('de')
  const value = useMemo(() => ({ mode, setMode }), [mode]);
  return <LanguageModeContext.Provider value={value}>{children}</LanguageModeContext.Provider>;
};

export const useLanguageMode = () => {
  const ctx = useContext(LanguageModeContext);
  if (!ctx) throw new Error('useLanguageMode must be used within LanguageModeProvider');
  return ctx;
};

export const bilingual = (mode: LanguageMode, de: string, en: string) => {
  if (mode === 'dual') return `${de} / ${en}`;
  return mode === 'de' ? de : en;
};

export const LanguageToggle: React.FC<{ className?: string }> = ({ className }) => {
  const { mode, setMode } = useLanguageMode();
  const base = 'px-2 py-1 text-xs rounded border cursor-pointer';
  return (
    <div className={`flex items-center gap-2 ${className ?? ''}`}>
      <button
        onClick={() => setMode('de')}
        className={`${base} ${mode === 'de' ? 'bg-yellow-400 text-black border-yellow-500' : 'border-gray-600 text-gray-300 hover:text-yellow-400'}`}
      >DE</button>
      <button
        onClick={() => setMode('en')}
        className={`${base} ${mode === 'en' ? 'bg-yellow-400 text-black border-yellow-500' : 'border-gray-600 text-gray-300 hover:text-yellow-400'}`}
      >EN</button>

    </div>
  );
};